// extracted by mini-css-extract-plugin
module.exports = {"v-hero":"v-hero_v-hero_2PYhs","background-image":"v-hero_background-image_2FpHQ","slot":"v-hero_slot_13J_m"};